import { post } from "../../service/api";

const CreateFunctionCall = async (values) => {
  try {
    const response = await post(`/ai/functionCalls`, values);
    return response;
  } catch (error) {
    console.error("Error CreateFunctionCall:", error);
    throw error;
  }
};

export default CreateFunctionCall;
